/**
 * Conference banners come in two kinds and want opposite fitting.
 *
 * A photographic banner (2025's PNG, 3.74:1) is meant to bleed to the edges, so
 * `object-cover` is right: cropping a photo loses nothing that matters.
 *
 * A wordmark/logo banner (2026's SVG, 2.39:1) must not be cropped — under
 * `object-cover` the DCMI 2026 mark lost about 10% off each side on the home page
 * and its lower half on the issues listing, clipping the sun glyph, the final
 * digit and the strapline. Those have to be fitted inside the box instead.
 *
 * SVG is the practical signal for "this is artwork, not a photograph": every
 * banner delivered as SVG so far is a mark, and photographs are never SVG.
 *
 * @param {string | null | undefined} banner filename from `conference.banner`
 * @returns {boolean} true when the banner should be fitted rather than cropped
 */
export function isMarkBanner(banner) {
	return /\.svg($|\?)/i.test(banner ?? '');
}

/**
 * Tailwind classes for fitting a banner of either kind.
 * @param {string | null | undefined} banner filename from `conference.banner`
 * @returns {string}
 */
export function bannerFitClass(banner) {
	return isMarkBanner(banner) ? 'bg-white object-contain p-6' : 'object-cover';
}
